module.exports = __webpack_public_path__ + "img/project9_4.jpg.cd11ab87.webp";